export enum ApplicationChannel {
  Unknown,
  Digital,
  Branch,
  AssistedForPrivateWealth,
  JointAppFromOlb,
  JointAppFromCsr,
  Authenticated
}
